import React, { memo } from 'react';
import { Eye16Regular } from '@fluentui/react-icons';
import BlockMarkdown from './BlockMarkdown';
import ClaimSupportFooter from '../ClaimSupportFooter';
import { extractBlockMarkdown } from './structuredBlockUtils';
import styles from './structuredResponse.module.css';

function BlockShell({ title, children, actions, className = '' }) {
    return (
        <section className={`${styles.blockShell} ${className}`.trim()}>
            {(title || actions) && (
                <header className={styles.blockHeader}>
                    {title ? <h3 className={styles.blockTitle}>{title}</h3> : <span />}
                    {actions ? <div className={styles.blockActions}>{actions}</div> : null}
                </header>
            )}
            <div className={styles.blockBody}>{children}</div>
        </section>
    );
}

function EvidenceAction({ onViewEvidence }) {
    if (!onViewEvidence) return null;
    return (
        <button type="button" className={styles.blockActionButton} onClick={onViewEvidence}>
            <Eye16Regular aria-hidden />
            View evidence
        </button>
    );
}

function ExecutiveSummaryBlock({ block, renderContext }) {
    const content = extractBlockMarkdown(block);
    if (!content) return null;
    return (
        <BlockShell
            title={block.title || 'Executive summary'}
            className={styles.executiveSummaryBlock}
            actions={<EvidenceAction onViewEvidence={renderContext?.onViewEvidence} />}>
            <BlockMarkdown content={content} {...renderContext} />
            <ClaimSupportFooter block={block} renderContext={renderContext} />
        </BlockShell>
    );
}

export default memo(ExecutiveSummaryBlock);
